module.exports = __webpack_public_path__ + "static/img/scene4.37534ec8.png";